/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import HeaderInfo from "../components/common/HeaderInfo";
import DataTable from "../components/common/DataTable";
import { Edit, Delete, SecurityIcon } from "../components/icons";
import RoleModal from "../components/modals/RoleModal";
import { useGetRolesQuery } from "../store/api";

export default function Roles() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRole, setSelectedRole] = useState(null);
  const [search, setSearch] = useState("");
  const { data, isLoading } = useGetRolesQuery();

  const columns = [
    { key: "identity", label: "Role Identity", className: "col-span-3" },
    { key: "scope", label: "Permissions Scope", className: "col-span-5" },
    {
      key: "staff",
      label: "Staff Count",
      className: "col-span-3 text-center ",
    },
    { key: "actions", label: "Actions", className: "col-span-1 text-center" },
  ];

  const filteredRoles = (data?.data || []).filter((role) =>
    role?.roleName.toLowerCase().includes(search.toLowerCase()),
  );

  const rows = filteredRoles.map((role) => ({
    id: role?._id,
    role: role?.roleName,
    permissions: role?.routePermissions || [],
  }));
  const renderRow = (r, idx) => (
    <div
      key={idx}
      className="bg-[#EEEEEE40]"
    >
      <div className="grid grid-cols-12 gap-4 px-7 py-6 items-center border-b border-[#E5E5E5]">
        <div className="col-span-3 ml-2 flex items-center  gap-2 text-black">
          <div className="w-[37px] h-[37px] bg-[#6D4E8A] rounded-full flex items-center justify-center">
            <SecurityIcon />
          </div>
          <div>
            <p className="capitalize">{r.role}</p>
          </div>
        </div>

        <div className="col-span-5 flex flex-wrap gap-2">
          {r.permissions.includes("all") ? (
            <p className="capitalize border border-[#CECECE] bg-[#D3FDC6] rounded-[10px] text-black py-1 max-w-48 w-full text-center">
              Full System
            </p>
          ) : (
            r.permissions.map((itm, i) => (
              <p
                key={i}
                className="capitalize border border-[#CECECE] bg-[#EFEFEF] rounded-[10px] text-black py-1 px-3"
              >
                {itm}
              </p>
            ))
          )}
        </div>

        <div className="col-span-3 text-center leading-[31px] text-black ">
          Linked to System
        </div>

        <div className="col-span-1 flex justify-center gap-3">
          <button
            aria-label="edit"
            className="cursor-pointer"
            onClick={() => {
              setSelectedRole(r);
              setModalMode("edit");
              setIsModalOpen(true);
            }}
          >
            <Edit />
          </button>

          {/* <button aria-label="delete" className="cursor-pointer">
            <Delete />
          </button> */}
        </div>
      </div>
    </div>
  );

  const handleOpenModal = () => {
    setSelectedRole(null);
    setModalMode("add");
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRole(null);
    setModalMode("add");
  };

  return (
    <div className="pt-6 md:pt-14 px-4 md:pl-8 md:pr-12 min-h-screen">
      <HeaderInfo
        title="Access Roles"
        desc="Define and manage granular permission sets for system users"
        btnLabel="Execute New Role"
        onAdd={handleOpenModal}
        isSearchBar={true}
        searchPlaceholder="Filter Access by Role Name"
        showFilterButton={false}
        searchValue={search}
        onSearchChange={setSearch}
      />

      <div className="mt-6 ml-0 md:ml-2.5">
        {isLoading ? (
          <p className="text-sm text-[#6B7280]">Loading roles...</p>
        ) : (
          <DataTable columns={columns} rows={rows} renderRow={renderRow} />
        )}
      </div>

      <RoleModal
        open={isModalOpen}
        onClose={handleCloseModal}
        mode={modalMode}
        role={selectedRole}
      />
    </div>
  );
}
